// Applicant area API — aggregates everything the applicant home needs from
// the live backend: the tracked application (by reference), its video KYC
// state, and (once active) the digital-banking choices.
import { getApplicantStatus, type TrackedApplication } from './onboarding';
import { getVideoKyc, type VideoKycStatus } from './vkyc';
import { getDigitalBanking, type DigitalBankingData } from './digitalBanking';
import { getSession } from './session';

export interface ApplicantHomeData {
  application: TrackedApplication;
  videoKyc: VideoKycStatus | null;
  digitalBanking: DigitalBankingData | null;
}

const isActiveStatus = (status: string): boolean =>
  ['ACTIVE', 'ACTIVATED', 'ACTIVE_FULL_KYC', 'ACTIVE_LIMITED_KYC'].includes(status.toUpperCase());

export const getApplicantHome = async (reference: string): Promise<ApplicantHomeData> => {
  const application = await getApplicantStatus(reference, getSession()?.mobileNumber);
  // Video KYC matters from submission until approval; a failure to load it
  // must not break the home.
  const videoKyc = await getVideoKyc(application.applicationId).catch(() => null);
  const digitalBanking = isActiveStatus(application.status)
    ? await getDigitalBanking(application.applicationId).catch(() => null)
    : null;
  return { application, videoKyc, digitalBanking };
};
